import { HStack, Spacer, VStack } from "@/components/Layout";
import {
  FloatingActionButton,
  HistoryItem,
  type OperationPackageParams,
  TableofContentsLeftRail,
} from "@/features/history";
import { createFileRoute } from "@tanstack/react-router";
import { useRef } from "react";
import usePersonParams from "../../-hooks/usePersonParams";
import useGetPersonHistories from "./-queries/useGetPersonHistories";
import { OWNER_PRODUCT_TO_OPERATION_PACKAGE_URL } from "@/features/history/utils/history-to-operation-package-url";

export const Route = createFileRoute("/_staff/person/$id/_profile/history/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = usePersonParams();
  const { data } = useGetPersonHistories({ personId: id });

  const ref = useRef<HTMLDivElement>(null);

  const handleDetailClick = (params: OperationPackageParams) => {
    const basePath =
      OWNER_PRODUCT_TO_OPERATION_PACKAGE_URL[params.ownerProduct];
    const url = `${basePath}/operation-packages/${params.operationPackageId}/patterns/${params.operationPackagePatternId}/instances/${params.operationPackageInstanceId}/data`;
    window.open(url, "_blank");
  };

  return (
    <HStack className="h-full p-10 gap-8">
      <nav className="sticky top-0 h-fit w-[240px]">
        <TableofContentsLeftRail
          historiesGroupByValidFrom={data.historiesGroupByValidFrom}
          basePath={`/person/${id}/history`}
        />
      </nav>
      <VStack ref={ref} className="w-full relative">
        <FloatingActionButton />
        <Spacer size={24} />
        <HistoryItem
          historiesGroupByValidFrom={data.historiesGroupByValidFrom}
          onDetailClick={handleDetailClick}
        />
      </VStack>
    </HStack>
  );
}
